import React from "react";
import history from "../History";
import { Text } from "react-internationalization";

const BannerZip = (props) => {
  //const { header, Body } = props;
  return (
    <div>
      <div class="jumbotron-web">
        <div class="enroll-header-content enroll-header-content2 enroll-header-bg2">
          <div class="enroll-header-content-width2">
          </div>
        </div>
      </div>
    </div>
  );
};
export default BannerZip;
